/** Base URL publique CRA (ex. /full en prod catalogue). */
export const PUBLIC_BASE = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

/** Catalogue servi à la racine du basename (/full → route React "/"). */
export const CATALOG_AT_SUBPATH_ROOT = PUBLIC_BASE === '/full';

export const ROUTER_BASENAME = CATALOG_AT_SUBPATH_ROOT ? '/full' : undefined;

export const MAIN_SITE_URL =
  process.env.REACT_APP_MAIN_SITE_URL ||
  (CATALOG_AT_SUBPATH_ROOT ? 'https://otrstudio.fr' : '');
